var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoPool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0Z",
    fill: "#DDDDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0002 12C7.5602 12 7.2002 11.64 7.2002 11.2V8C7.2002 7.56 7.5602 7.2 8.0002 7.2C8.4402 7.2 8.8002 7.56 8.8002 8V11.2C8.8002 11.64 8.4402 12 8.0002 12Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8002 5.6H7.2002V4H8.8002V5.6Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPool);
export default __webpack_public_path__ + "static/media/info_pool.276b7966ed624e135d0af5d748fa03e5.svg";
export { ForwardRef as ReactComponent };